import { detectEmbedMode } from './embedMode';

export interface AgentCreatedPayload {
  agentType: 'call' | 'chat';
  agentId: string;
  agentName?: string;
}

const postToParent = (
  type: 'elora:agent:created' | 'elora:embed:close',
  payload?: unknown
): void => {
  if (!detectEmbedMode() || typeof window === 'undefined') {
    return;
  }

  try {
    if (window.parent && window.parent !== window.self) {
      window.parent.postMessage(
        {
          type,
          payload,
        },
        '*'
      );
    }
  } catch (error) {
    console.warn('[EloraEmbed] Failed to post message to parent:', error);
  }
};

export const notifyAgentCreated = (payload: AgentCreatedPayload): void => {
  postToParent('elora:agent:created', payload);
};

export const notifyEmbedClose = (): void => {
  postToParent('elora:embed:close');
};

export const CALENDAR_OAUTH_MESSAGE_TYPE = 'elora:calendar:oauth';

export interface CalendarOAuthMessage {
  type: typeof CALENDAR_OAUTH_MESSAGE_TYPE;
  success: boolean;
  error?: string;
}

export const notifyCalendarOAuthResult = (
  payload: Omit<CalendarOAuthMessage, 'type'>
): void => {
  if (typeof window === 'undefined' || !window.opener || window.opener.closed) {
    return;
  }

  window.opener.postMessage(
    {
      type: CALENDAR_OAUTH_MESSAGE_TYPE,
      ...payload,
    },
    window.location.origin
  );
};

export const listenForCalendarOAuthResult = (
  onResult: (success: boolean, error?: string) => void
): (() => void) => {
  const handler = (event: MessageEvent) => {
    if (event.origin !== window.location.origin) {
      return;
    }

    const data = event.data as CalendarOAuthMessage | undefined;
    if (data?.type !== CALENDAR_OAUTH_MESSAGE_TYPE) {
      return;
    }

    onResult(data.success, data.error);
  };

  window.addEventListener('message', handler);
  return () => window.removeEventListener('message', handler);
};
